import { canNavigate } from '@/plugins/acl/routeProtection'
import Vue from 'vue'
import VueRouter from 'vue-router'
import dashboard from './dashboard'
import pages from './pages'
import productcategories from './productcategories'
import products from './products'
import countries from './countries'
import users from './users'
import orderstatuses from './orderstatuses'
import members from './members'
import manifests from './manifests'
import addresses from './addresses'
import orders from './orders'
import items from './items'
import invoices from './invoices'
import orderextras from './orderextras'
import clickcollectretailers from './clickcollectretailers'
import discountcodes from './discountcodes'
import reports from './reports'
import logs from './logs'
import settings from './settings'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: to => {
      const userData = JSON.parse(localStorage.getItem('userData'))
      const userRole = userData && userData.Role ? userData.Role : null
      if (userRole === 'member') return { name: 'auth-login', query: to.query }
      else {
        return { name: 'dashboard' }
      }
    },
  },
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/views/Error404.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
    },
  },
  {
    path: '/login',
    name: 'auth-login',
    component: () => import('@/views/pages/authentication/Login.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/forgot-password',
    name: 'auth-forgot-password',
    component: () => import('@/views/pages/authentication/ForgotPassword.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/reset-password/:code',
    name: 'auth-reset-password',
    component: () => import('@/views/pages/authentication/ResetPassword.vue'),
    props: true,
    meta: {
      layout: 'blank',
      resource: 'Public',
      redirectIfLoggedIn: true,
    },
  },
  ...dashboard,
  ...pages,
  ...productcategories,
  ...products,
  ...countries,
  ...users,
  ...orderstatuses,
  ...members,
  ...manifests,
  ...addresses,
  ...orders,
  ...items,
  ...invoices,
  ...orderextras,
  ...clickcollectretailers,
  ...discountcodes,
  ...reports,
  ...logs,
  ...settings,
  {
    path: '*',
    redirect: 'error-404',
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
})

// ? Router Before Each hook: https://router.vuejs.org/guide/advanced/navigation-guards.html
router.beforeEach((to, _, next) => {
  const userData = localStorage.getItem('userData')

  const isLoggedIn = userData && localStorage.getItem('accessToken') && localStorage.getItem('userAbility')

  if (!canNavigate(to)) {
    // Redirect to login if not logged in
    if (!isLoggedIn) return next({ name: 'auth-login', query: { marketplace: to.query.marketplace } })

    // If logged in => not authorized
    return next({ name: 'misc-not-authorized' })
  }

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    next('/')
  }

  return next()
})

export default router
